module.exports = __webpack_public_path__ + "assets/img/exchange_btn.70379680.png";